import React from 'react';
import { stats } from '../data/mock';

const Stats = () => {
  return (
    <section className="relative py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-6 md:px-8">
        <p className="text-center text-sm md:text-base text-white/60 max-w-2xl mx-auto leading-relaxed">
          A indústria de bets gasta bilhões em anúncios para te alcançar onde você passa o dia: Instagram, Facebook e Google.
          <span className="text-white"> O Anjora corta o gatilho na fonte</span> — antes do clique virar aposta.
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-12">
          {stats.map((s) => (
            <div
              key={s.label}
              className="gradient-border p-6 text-center hover:bg-white/[0.05] transition-colors duration-300"
            >
              <p className="text-3xl md:text-4xl font-extrabold gradient-text">{s.value}</p>
              <p className="text-xs md:text-sm text-white/60 mt-2">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
